const invoiceTypes = [
	{ value: 'customer-fee', label: 'Customer fee' },
	{ value: 'trip-commission', label: 'Trip commission' },
	{ value: 'express-editing', label: 'Express editing' },
	{ value: 'admin-fee', label: 'Admin fee' },
	{ value: 'airbnb', label: 'Airbnb' },
	{ value: 'other', label: 'Other' },
];

export default invoiceTypes;
